import { Component, inject, OnInit } from '@angular/core';
import { BaseEntityComponent, BnLoadingService } from '@bndes/bndes-ux4/bndes-angular-utils';
import { DetalheDistribuicaoLimiteAgenteDto } from 'src/app/model/detalhe-distribuicao-limite-agente-dto.model';
import { DistribuicaoLimiteAgentesService } from '../distribuicao-agentes/distribuicao-limite-agente.service';
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLinkBase, NgbNavLinkButton, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { BnMaskPipe } from '@bndes/bndes-ux4/bn-mask/bn-mask-pipe';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-distribuicao-agentes-detalhe',
  imports: [
    NgbNavContent, 
    NgbNav, 
    NgbNavItem, 
    NgbNavItemRole, 
    NgbNavLinkButton, 
    NgbNavLinkBase, 
    NgbNavOutlet, 
    FormsModule,
    BnMaskPipe, 
    DatePipe],
  templateUrl: './distribuicao-agentes-detalhe.component.html',
  styleUrl: './distribuicao-agentes-detalhe.component.scss',
  standalone: true
})
export class DistribuicaoAgentesDetalheComponent extends BaseEntityComponent<DetalheDistribuicaoLimiteAgenteDto> 
  implements OnInit{

  public detalheAgente: DetalheDistribuicaoLimiteAgenteDto;
  public idCiclo: number;
  private idAgenteModalidade: number;

  private readonly distribuicaoAgentesService = inject(DistribuicaoLimiteAgentesService);
  private readonly loadingService = inject(BnLoadingService);

  constructor(distribuicaoAgentesService: DistribuicaoLimiteAgentesService) { 
    super(distribuicaoAgentesService);
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.idCiclo = params['idCiclo'];
      this.idAgenteModalidade = params['idAgenteModalidade'];

      this.buscarAgente();
    })
  }

  buscarAgente() {
    this.loadingService.bloqueiaTela()
    this.distribuicaoAgentesService.buscarAgentePorCicloModalidade(this.idCiclo, this.idAgenteModalidade)
    .pipe(finalize(() => this.loadingService.liberaTela()))
    .subscribe({
      next: (detalheAgente: DetalheDistribuicaoLimiteAgenteDto) => {
        this.detalheAgente = detalheAgente;
      },
      error: err => {
        console.error(err);
      },
      
    });
  }

  voltar() {
    this.router.navigate(['/distribuicao-limites-detalhes', this.idCiclo]);
  }
}
